import React from 'react';
import DividerSquiggle from '../../assets/icons/DividerSquiggle.js';
const HomeHeroImage = () => {
  return (
    <div className="home-hero-image">
      <DividerSquiggle color="white" />
      <h2>
        let’s
        <br /> make
        <br /> something
      </h2>
      <DividerSquiggle color="white" />
    </div>
  );
};

export default HomeHeroImage;
